var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowsWhite = function SvgArrowsWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97689 7.64039L5.38489 7.16839C5.54489 6.98439 5.77689 6.87239 6.02489 6.87239H8.72089L8.54489 7.74439C8.49689 7.96839 8.75289 8.12839 8.93689 7.99239L11.1929 6.32039C11.3289 6.22439 11.3289 6.02439 11.1929 5.92039L8.93689 4.24839C8.75289 4.11239 8.49689 4.27239 8.54489 4.49639L8.72089 5.36839H5.97689C5.28089 5.36839 4.71289 5.93639 4.71289 6.63239V7.53639C4.71289 7.68039 4.88889 7.74439 4.97689 7.64039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.025 8.36015L10.617 8.83215C10.457 9.01615 10.225 9.12815 9.97703 9.12815H7.28103L7.45703 8.25615C7.50503 8.03215 7.24903 7.87215 7.06503 8.00815L4.80903 9.68015C4.67303 9.77615 4.67303 9.97615 4.80903 10.0802L7.05703 11.7522C7.24103 11.8882 7.49703 11.7282 7.44903 11.5042L7.28103 10.6322H10.025C10.721 10.6322 11.289 10.0642 11.289 9.36815V8.46415C11.289 8.32015 11.113 8.25615 11.025 8.36015Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowsWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowsWhite.58a85ba8.svg";
export { ForwardRef as ReactComponent };